import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  IconInfoComponent,
  IconPaymentComponent,
  IconShippingComponent,
} from '@pedix-workspace/angular-ui-icons';
import {
  PurchaseOptions,
  PurchaseRestrictable,
  formatRestrictionNames,
  getPurchaseRestrictionLabels,
} from '@pedix-workspace/utils';

@Component({
  selector: 'pxw-product-restriction-tags',
  templateUrl: './product-restriction-tags.component.html',
  styleUrls: ['./product-restriction-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, IconInfoComponent, IconShippingComponent, IconPaymentComponent],
})
export class ProductRestrictionTagsComponent {
  readonly product = input.required<PurchaseRestrictable | null>();
  readonly purchaseOptions = input.required<PurchaseOptions | null>();
  readonly compact = input(false);

  readonly labels = computed(() => {
    const product = this.product();

    return product
      ? getPurchaseRestrictionLabels(product, this.purchaseOptions())
      : { shipping: null, payment: null };
  });

  formatNames(names: string[], conjunction: string): string {
    return formatRestrictionNames(names, conjunction);
  }
}
